<script>
    import user from '../state/user';

    export let clnId;
    export let code;

    let submitting = false;

    let form = {
        pass: '',
        passRepeat: ''
    };

    let valid = {
        pass: null,
        passRepeat: null
    };

    let message = {
        contents: '',
        isError: false
    };

    let userName = '';
    let showForm = null;

    let formIsValid = null;

    let initialized = false;
    $: formUpdated(form);
    function formUpdated(form) {
        if (!initialized) {
            initialized = true;
            return console.log('Not initialized, initializing ...');
        }

        valid.pass = !!form.pass.length;

        if (!form.passRepeat.length) {
            valid.passRepeat = null;
        } else {
            valid.passRepeat = (form.pass === form.passRepeat);
        }

        formIsValid = (valid.pass && valid.passRepeat);
    }

    function onLoad() {
        user.password(clnId, code).then((res) => {
            if (res) {
                showForm = true;
                userName = res['name'];
            } else {
                showForm = false;
                userName = null;
            }
        });
    }

    async function onSubmit() {
        if (!formIsValid) return;

        submitting = true;
        await user.setupPassword(clnId, code, form.pass);
        submitting = false;

        message.contents = 'Heslo bylo úspěšně nastaveno!';
        message.isError = false;
        showForm = false;
    }

    // Check client and code
    onLoad();
</script>

<style>
    .controls {
        position: absolute;
        bottom: 20px;
        z-index: 1;
    }

    .modal-card-foot { padding: 38px 20px; }
</style>

<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <div class="modal-card-title">
                Nastavení hesla účtu
            </div>
        </header>
        <section class="modal-card-body">
            {#if showForm === true}
                {#if message.isError}
                    <div class="notification is-danger">
                        {message.contents}
                    </div>
                {/if}

                <form on:submit|preventDefault={onSubmit}>
                    <div class="field">
                        <label class="label" for="password">Heslo</label>

                        <div class="control has-icons-right">
                            <input class="input" name="password" type="password" placeholder="Nové heslo" id="password"
                                class:is-success={valid.pass === true}
                                class:is-danger={valid.pass === false}
                                bind:value={form.pass}
                                autocomplete="new-password"
                                required>

                            {#if valid.pass !== null}
                                <span class="icon is-small is-right">
                                    {#if valid.pass}
                                        <i class="fas fa-check"></i>
                                    {:else}
                                        <i class="fas fa-exclamation-triangle"></i>
                                    {/if}
                                </span>
                            {/if}
                        </div>
                    </div>

                    <div class="field">
                        <label class="label" for="passwordRepeat">Heslo znovu</label>

                        <div class="control has-icons-right">
                            <input class="input" name="password-repeat" type="password" placeholder="Nové heslo znovu - pro kontrolu" id="passwordRepeat"
                                class:is-success={valid.passRepeat === true}
                                class:is-danger={valid.passRepeat === false}
                                bind:value={form.passRepeat}
                                autocomplete="new-password"
                                required>

                            {#if valid.passRepeat !== null}
                                <span class="icon is-small is-right">
                                    {#if valid.passRepeat}
                                        <i class="fas fa-check"></i>
                                    {:else}
                                        <i class="fas fa-exclamation-triangle"></i>
                                    {/if}
                                </span>
                            {/if}

                            {#if valid.passRepeat === false}
                                <p class="help is-danger">Zadaná hesla nejsou stejná</p>
                            {/if}
                        </div>
                    </div>

                    <div class="controls">
                        <button class="button"
                                class:is-loading={submitting}
                                disabled={!formIsValid}>
                            Uložit
                        </button>
                    </div>
                </form>
            {:else if showForm === null}
                Načítání ...
            {:else if message.contents && message.contents.length}
                <div class="notification is-success">
                    {message.contents}
                </div>

                <div class="controls">
                    <a class="button" href="/">Přejít do rezervačního systému</a>
                </div>
            {:else}
                <div class="notification is-danger">
                    Při načítání došlo k chybě, zkontrolujte odkaz!
                </div>
            {/if}
        </section>

        <footer class="modal-card-foot"></footer>
    </div>
</div>